import { BrandThemeProvider, Text } from '@ltvco/refresh-lib/theme';
import { BackdropLoading, isUserLoggedIn } from '@ltvco/refresh-lib/v2';
import { useEffect, useState } from 'react';

import { theme } from '../theme';

export function ThemeWrapper({
  children,
  isGbReady,
}: {
  children: JSX.Element;
  isGbReady: boolean;
}) {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (!isUserLoggedIn()) {
      setShowLoading(false);
      return;
    }
    if (!isGbReady) {
      setShowLoading(true);

      setTimeout(() => {
        setShowLoading(false);
      }, 10000);

      return;
    }

    setShowLoading(false);
  }, [isGbReady]);

  const isTestingEnv = import.meta.env.VITE_IS_TEST;
  const isInFirstReportFlow =
    sessionStorage.getItem('first_report_generating') !== null ||
    localStorage.getItem('recordSearch') !== null ||
    localStorage.getItem('show_first_report_screen') !== null;

  return (
    <BrandThemeProvider theme={theme}>
      {showLoading && !isTestingEnv && !isInFirstReportFlow ? (
        <BackdropLoading
          message={<Text variant="h5">Fetching account</Text>}
          sx={{ backgroundColor: 'white' }}
        />
      ) : (
        <>{children}</>
      )}
    </BrandThemeProvider>
  );
}
